<template>
  <div class="view">
    <v-card max-width="300">
      <div class="px-10 py-5 d-flex flex-column align-center">
        <h2 class="">{{ text }}</h2>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "not-found",

  props: {
    text: {
      type: String,
      default: "404 Not Found",
    },
  },

  data() {
    return {};
  },

  // We have added a simple method to add new greetings to our Firebase.
  methods: {},

  mounted() {
    console.log("NotFound mounted.");
  },

  created() {},

  destroyed() {
    console.log("NotFound destroyed.");
  },
};
</script>

<style scoped lanf="scss">
.view {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 100vh;
}

.logo {
  height: 80px;
  margin-bottom: 25px;
}
</style>
